import { useState } from "react";
import { actionGetRpTDispositivos } from "../../../features/relatorios/rptDispositivos/slices";
import factoryFields from "../../../helpers/factory-fields";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import Alert from "../../Alert";
import Button from "../../Button";
import Select from "../../Select";

const RptDispositivos = () => {
  const [reportType, setReportType] = useState("");
  const dispatch = useAppDispatch();
  const {
    getRptDispositivos: { noContent, status },
  } = useAppSelector((state) => state);

  const [value, setValue] = useState("");

  const handlerChange = (e: any) => {
    setValue(e.target.value);
    setReportType(e.target.value);
  };

  const handlerReportDispositivos = () => dispatch(actionGetRpTDispositivos(reportType));
  
  return (
    <div className="container">
      <div className="mb-20">
        {noContent && status === "success" && <Alert type="success">Nenhum relatório encontrado</Alert>}
      </div>
      <div className="row">
        <div className="col-6">
          <div className="mb-20">
            <Select
              options={factoryFields.typesReport}
              size="sm"
              label="Formato do arquivo"
              value={value}
              onChange={handlerChange}
            />
          </div>
          <Button
            size="sm"
            onClick={handlerReportDispositivos}
            loading={status === "loading"}
          >
            Baixar Relatório
          </Button>
        </div>
      </div>
    </div>
  );
};


export default RptDispositivos